import * as React from "react";
import './index.css';
import { useHistory } from 'react-router-dom';
import { Button } from '@material-ui/core';

const NotFoundPage = () => {
	const history = useHistory();
	return <div id="notfound">
		<div class="notfound">
			<div class="notfound-404"></div>
			<h1>404</h1>
			<h2>Oops! Page Can Not Be Found</h2>
			<p>Sorry but the page you are looking for does not exist, have been removed. name changed or is temporarily unavailable</p>
			<Button
				//className={classes.navItemButton}
				id="transfer-button"
				variant="text"
				disableRipple
				onClick={() => history.push("/")}
			>
				Back to homepage
                        </Button>
		</div>
	</div>;
}

export default NotFoundPage;